var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "160px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 121.4 161.5",
    style: {
      enableBackground: "new 0 0 121.4 161.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4caf50;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63,6.8c12,5.5,20.7,16.5,26.9,25.8c6.2,9.4,9.9,17.2,12.8,24.7c2.9,7.5,5,14.6,8.5,23.7s8.4,20.2,8,31.9 c-0.4,11.7-6.1,24.2-15.8,31.8c-9.7,7.7-23.4,10.6-38,12c-14.7,1.5-30,1.4-41.6-5.2c-11.6-6.6-19.3-19.8-21-33 C1,105.3,5.2,92.2,10.7,82.1C16.1,72,22.7,65,24.6,52c1.9-12.9-1-31.8,5.2-41.2C36,1.4,51,1.4,63,6.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape4);
export default __webpack_public_path__ + "static/media/shape-4.e14737c802f085d880996a73f1bff07d.svg";
export { ForwardRef as ReactComponent };